import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

/** Map legacy ?tab= values to new route segments */
const TAB_TO_ROUTE: Record<string, string> = {
  branding: "branding",
  menu: "quick-links",
  social: "social-links",
  domains: "domains",
  billing: "billing",
};

export const Route = createFileRoute("/$orgSlug/admin/settings")({
  beforeLoad: ({ location, params, search }) => {
    const { orgSlug } = params;
    const base = `/${orgSlug}/admin/settings`;

    // Legacy ?tab= redirect
    const tab = (search as Record<string, unknown>).tab as string | undefined;
    if (tab && TAB_TO_ROUTE[tab]) {
      throw redirect({
        to: `/$orgSlug/admin/settings/${TAB_TO_ROUTE[tab]}` as "/$orgSlug/admin/settings/branding",
        params: { orgSlug },
      });
    }

    // Bare /settings → /settings/branding
    if (
      location.pathname === base ||
      location.pathname === `${base}/`
    ) {
      throw redirect({
        to: "/$orgSlug/admin/settings/branding",
        params: { orgSlug },
      });
    }
  },
  component: () => <Outlet />,
});
